<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        Data Table
        <date-range-picker
              :startDate="startDate"
              :endDate="endDate"
              @update="console.log(value)"
              :locale-data="locale">
          </date-range-picker>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable">
          <div slot="actions" slot-scope="props">
            <a target="_blank" href="#" class="fa fa-lg fa-search text-primary"></a>&nbsp;
            <a target="_blank" href="#" @click.prevent="editWaybill(props.row.id)" class="fa fa-lg fa-edit text-primary"></a>&nbsp;
            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger"></a>
          </div>

          <!--<div slot="child_row" slot-scope="props">-->
            <!--<div><b>First name:</b> {{props.row.company.address}}</div>-->
            <!--<div><b>Last name:</b> {{props.row.last_name}}</div>-->
          <!--</div>-->

        </v-client-table>

        <!--<hr>-->
        <!--<v-server-table :columns="columns" :options="options" id="dataTable"></v-server-table>-->
      </b-card-body>
    </b-card>

  </div>

</template>



<script>
  import Vue from 'vue'
  import {ClientTable, Event} from 'vue-tables-2'
  import moment from 'moment';
  import DateRangePicker from 'vue2-daterange-picker'

  Vue.use(ClientTable);

  export default {
    name: 'DataTable',
    components: {
      DateRangePicker,
      ClientTable,
    },

    created () {
      this.getWaybills()
    },
    data () {
      return {
        // Daterange Picker data
        startDate: '2019-09-05',
        endDate: '2019-09-15',
        locale: {
            direction: 'ltr', //direction of text
            format: 'DD-MM-YYYY', //fomart of the dates displayed
            separator: ' - ', //separator between the two ranges
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
            monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
            firstDay: 1 //ISO first day of week - see moment documenations for details
        },
        columns: [
          'client_customer_name',
          'number',
          'company_name',
          'waybill_date',
          'total_pallets',
          'total_kilograms',
          'actions'
        ],
        data: [],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        options: {
          texts: {
                filter: "Filtrar:",
                filterBy: 'Filtrar por {column}',
                count:' '
            },
          listColumns: {
            waybill_date: [{
                        id: 1,
                        text: 'Enero'
                    },
                    {
                        id: 2,
                        text: 'Febrero',
                    },
                    {
                        id: 3,
                        text: 'Marzo'
                    },
                    {
                        id: 4,
                        text: 'Abril'
                    }
                ]
          },
          perPage: 10,
          dateFormat: 'DD/MM/YYYY',
          // columnsDropdown: true,
          filterByColumn: true,
          headings: {
            number: 'Numero',
            company_name: 'Productor',
            client_customer_name: 'Exportadora',
            contact_name: 'Contacto',
            waybill_date: 'Fecha Guia',
          },
          sortable: ['number' ,'company_name'],
          filterable: ['client_customer_name', 'number','company_name', 'waybill_date'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            dropdown: false,
            chunk: 10
          }
        },

      }
    },
    methods: {
      getWaybills(){
        this.$axios.get ('/api/v1/waybill/')
        .then(res => {
          const data = res.data.results;
          const items = [];
          for(let key in data){
            const item = data[key];
            item.waybill_date = moment(item.waybill_date);
            items.push(item);
          }
          // console.log(items)
          this.data = items
        })
        .catch(error => console.log(errors))
      },
      deleteWaybill(a){
        console.log(a)
        this.$axios.delete ('/api/v1/waybill/'+a+'/')
          .then(res => {
            this.getWaybills()
          })
          .catch(error => console.log(errors))
      },
      editWaybill(a){
        this.$router.push('/recepcion/editar/'+a);
      }
    },
  };
</script>

<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .table td {
      padding: 0.30em;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.12rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }
    .VueTables__date-filter {
      border: 1px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
